import React from 'react';
import { Terminal } from 'lucide-react';

export const Contact: React.FC = () => {
  return (
    <section id="contact" className="py-32 bg-gray-50 relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.4]"
        style={{
          backgroundImage: 'radial-gradient(#cbd5e1 1px, transparent 1px)',
          backgroundSize: '24px 24px',
        }}
      />

      <div className="max-w-4xl mx-auto px-6 relative z-10">
        <div className="bg-[#0c0c0c] rounded-lg border border-gray-800 shadow-2xl p-1 overflow-hidden transform transition-all hover:scale-[1.01]">
          <div className="bg-[#1f1f1f] px-4 py-2 flex items-center gap-2 text-xs font-mono text-gray-400 border-b border-[#333]">
            <Terminal size={12} />
            <span>Developer PowerShell</span>
          </div>

          <div className="p-8 md:p-12 font-mono text-gray-200">
            <div className="mb-6 text-gray-400">
              <span className="text-green-500">PS C:\Ayum\Projects&gt;</span> ./Initiate-Contact.ps1
            </div>

            <div className="space-y-6">
              <h2 className="text-3xl md:text-4xl text-white font-bold mb-4">Ready to compile?</h2>
              <p className="text-gray-400 max-w-xl">
                We are listening on port 443. Throw us an exception, and we&apos;ll handle it. Whether it&apos;s a legacy
                migration or a greenfield SPA, we have the stack.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 pt-4">
                <a
                  href="mailto:hello@ayum.dev"
                  className="px-6 py-3 bg-white text-black font-bold hover:bg-js hover:text-black transition-colors text-center rounded-sm"
                >
                  Send(Message)
                </a>
                <a
                  href="#contact"
                  className="px-6 py-3 border border-gray-700 text-gray-300 hover:border-dotnet hover:text-white hover:bg-dotnet/20 transition-colors text-center rounded-sm"
                >
                  Schedule.Await()
                </a>
              </div>
            </div>

            <div className="mt-8 text-xs text-gray-600">
              <span>Process exited with code 0 (0x0)</span>
              <br />
              <span className="animate-pulse">_</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
